import * as Sentry from '@sentry/react';
import mixpanel from 'mixpanel-browser';

export const analyticsConfig: { accountId?: string } = {};

export function track(eventName: string, parameters?: Record<string, any>) {
  if (import.meta.env.NODE_ENV === 'development') {
    console.debug('[EVENT_TRACK]', eventName, 'parameters:', parameters);

    return;
  }

  try {
    mixpanel.track(eventName, {
      ...(parameters || {}),
      url: window.location.href,
      ...(analyticsConfig.accountId
        ? { account_id: [analyticsConfig.accountId] }
        : {}),
    });
  } catch (e) {
    Sentry.captureException(e);
    console.error('failed to send event to mixpanel', e);
    // TODO: report to sentry
  }

  // try {
  //   if (Hotjar.isReady()) {
  //     Hotjar.event(eventName);
  //   }
  // } catch (e) {
  //   console.error('failed to send event to hotjar');
  //   // TODO: report to sentry
  // }
}
